import wrapWithProviders from './wrap-with-providers';

export const wrapRootElement = wrapWithProviders;
